import React from 'react';
import { motion } from 'framer-motion';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
const BONUSES = [{
  number: 1,
  title: 'Libro de Trabajo de Reiki',
  desc: 'Ejercicios prácticos para integrar lo aprendido.',
  image: 'https://cdn.magicpatterns.com/uploads/aD3Rzvz9ZP5RFRn4kDkGzt/ChatGPT_Image_5_feb_2026,_16_27_39.png'
}, {
  number: 2,
  title: 'Guía de los 7 Chakras',
  desc: 'Emociones, bloqueos y equilibrio energético.',
  image: 'https://cdn.magicpatterns.com/uploads/sPkoe46vwtSddz9EgxNRu4/ChatGPT_Image_5_feb_2026,_16_27_43.png'
}, {
  number: 3,
  title: 'Guía de Meditación Reiki',
  desc: 'Meditaciones para profundizar tu práctica.',
  image: 'https://cdn.magicpatterns.com/uploads/5aZmLeTL5kP6YtJeo4ys2w/ChatGPT_Image_5_feb_2026,_16_48_24.png'
}];
export function BonusesSection() {
  return <section className="bg-amber-50/50 py-20 md:py-28 px-4 border-t border-amber-100" data-id="element-34">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-35">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-3 leading-tight" data-id="element-36">
          🎁 Bonos incluidos HOY
        </motion.h2>
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-green-700 font-bold text-lg mb-14" data-id="element-37">
          (gratis por tiempo limitado)
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-38">
          {BONUSES.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.12
        }} className="bg-white rounded-2xl p-6 shadow-md border border-amber-100 flex flex-col items-center text-center" data-id="element-39">
              <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="block mb-5 hover:scale-105 transition-transform" data-id="element-40">
                <img src={bonus.image} alt={bonus.title} className="w-full max-w-[240px] aspect-square object-cover rounded-xl shadow-sm mx-auto" data-id="element-41" />
              </a>
              <span className="inline-block bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wide" data-id="element-42">
                Bono #{bonus.number} — Gratis
              </span>
              <h3 className="text-lg font-serif font-bold text-gray-900 mb-1" data-id="element-43">
                {bonus.title}
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-44">{bonus.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}